export default class ApiAxios {

    constructor(axios) {
        this.axios = axios;
    //    this.pageStore = pageStore;
    }

    get(url, data) {
        return new Promise((resolve, reject) => {
            this.axios
                .get(url, data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    /*if (error.response.status === 401) {
                        this.pageStore.logout();
                        this.pageStore.loading = false;
                    } else if (error.response.status === 403) {
                        alert("Forbidden You don't have permission to access this page!");
                        this.pageStore.loading = false;
                        window.location.href = '/';
                    } else if (error.response.status === 404) {
                        //window.location.href='/';
                        window.location.href = '/page-not-found';
                    } else if (error.response.status === 302) {
                        window.location.href = error.response.data.redirectUrl;
                    } else {
                        console.log('Oops! something went wrong...');
                        this.pageStore.loading = false;
                        //window.location.href = '/page-not-found';
                    }*/
                    reject(error);
                });
        });
    }

    post(url, formData, callback) {
        return new Promise((resolve, reject) => {
            this.axios
                .post(url, formData)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    /*if (error.response.status === 422) {
                        if (callback) {
                            this.pageStore.loading = false;
                            callback(false, error.response.data);
                        }
                    } else if (error.response.status === 403) {
                        alert("Forbidden You don't have permission to access this page!");
                        this.pageStore.loading = false;
                        window.location.href = '/';
                    } else if (error.response.status === 401) {
                        this.pageStore.logout();
                        this.pageStore.loading = false;
                    } else if (error.response.status === 404) {
                        alert('Page Not Found');
                        window.location.href = '/page-not-found';
                    } else if (error.response.status === 302) {
                        window.location.href = error.response.data.redirectUrl;
                    } else {
                        if (callback) {
                            callback(false, null);
                        }
                        console.log('Oops! something went wrong...');
                        this.pageStore.loading = false;
                    }*/
                    reject(error);
                });
        });
    }
}



// WEBPACK FOOTER //
// ./resources/js/ApiAxios.js